import axiosInstance from '@/api/axiosInstance';
import { adoptSignInTenant, tokenStorage } from '@/api/tokenManager';
import { AUTH_ENDPOINTS } from '@/api/endpoints/auth.endpoints';
import { TokenResponse } from '@/types/authentication.types';

export const useLdapLogin = () => {
    const handleLdapLogin = async (providerId: number, username: string, password: string) => {
        try {
            const response = await axiosInstance.post<TokenResponse>(AUTH_ENDPOINTS.LDAP_LOGIN, {
                provider_id: providerId,
                username,
                password,
            });
            
            if (response.data.access_token) {
                tokenStorage.setTokens(response.data.access_token, response.data.refresh_token);
                adoptSignInTenant(response.data.access_token);
            }
            return response.data;
        } catch (err: any) {
            throw err;
        }
    };

    return {
        handleLdapLogin,
    };
};